import {
  SendHighStressNotificationData,
  ActionType,
} from "models/stressCheck/sendHighStressNotification";
import { IResponse } from "models";

export const sendHighStressNotificationAction = (
  payload: SendHighStressNotificationData
) => {
  return {
    type: ActionType.SEND_HIGH_STRESS_NOTIFICATION,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.SEND_HIGH_STRESS_NOTIFICATION_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.SEND_HIGH_STRESS_NOTIFICATION_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_SEND_HIGH_STRESS_NOTIFICATION,
  };
};
